(function () {
  const BADGE_SELECTOR = '[data-loyalty-earn-badge]';
  const proxyPath = '/apps/worldbalance/api/loyalty/display';
  const currencyCode =
    window.Shopify?.currency?.active ||
    document.documentElement.getAttribute('data-currency') ||
    'PHP';

  let displayRulePromise = null;
  let refreshFrame = null;

  function getProxyUrl() {
    const rootUrl = String(window.routes?.root_url || '/');
    const normalizedRoot = rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
    return `${normalizedRoot}${proxyPath}`;
  }

  function toPositiveNumber(value) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return null;
    }

    return parsed;
  }

  function formatPoints(points) {
    const normalized = Math.max(0, Math.floor(Number(points || 0)));
    const suffix = normalized === 1 ? 'point' : 'points';
    return `+ ${new Intl.NumberFormat('en-US').format(normalized)} ${suffix}`;
  }

  async function fetchDisplayRule() {
    if (!displayRulePromise) {
      displayRulePromise = (async () => {
        const formData = new FormData();
        formData.append('currencyCode', currencyCode);

        const response = await fetch(getProxyUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        });

        const result = await response.json();
        if (!response.ok || result?.status !== 'ready') {
          return null;
        }

        return result.displayRule || null;
      })().catch(() => null);
    }

    return displayRulePromise;
  }

  function updateBadge(badge, rule) {
    if (!badge) {
      return;
    }

    const earnPesoPerPoint = toPositiveNumber(rule?.earnPesoPerPoint);
    const priceCents = Math.max(0, Number(badge.dataset.priceCents || 0));

    if (!earnPesoPerPoint || priceCents <= 0) {
      badge.hidden = true;
      return;
    }

    const priceValue = priceCents / 100;
    const earnedPoints = Math.floor(priceValue / earnPesoPerPoint);

    if (earnedPoints <= 0) {
      badge.hidden = true;
      return;
    }

    const label = badge.querySelector('[data-loyalty-earn-label]');
    if (label) {
      label.textContent = formatPoints(earnedPoints);
    }

    badge.hidden = false;
  }

  async function renderBadges() {
    const badges = Array.from(document.querySelectorAll(BADGE_SELECTOR));
    if (badges.length === 0) {
      return;
    }

    const displayRule = await fetchDisplayRule();
    badges.forEach((badge) => updateBadge(badge, displayRule));
  }

  function scheduleRender() {
    if (refreshFrame !== null) {
      cancelAnimationFrame(refreshFrame);
    }

    refreshFrame = requestAnimationFrame(() => {
      refreshFrame = null;
      renderBadges();
    });
  }

  function shouldRefreshFromMutation(mutations) {
    return mutations.some((mutation) => {
      if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) {
        return false;
      }

      return Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) {
          return false;
        }

        return (
          node.matches?.(BADGE_SELECTOR) ||
          node.querySelector?.(BADGE_SELECTOR) ||
          node.matches?.('.cart-drawer, cart-drawer, cart-drawer-items') ||
          node.querySelector?.('.cart-drawer, cart-drawer, cart-drawer-items')
        );
      });
    });
  }

  function initObserver() {
    if (!document.body) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      if (shouldRefreshFromMutation(mutations)) {
        scheduleRender();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('cart:updated', scheduleRender);
  document.addEventListener('section:cached', scheduleRender);
  document.addEventListener('quantity-selector:update', scheduleRender);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function onReady() {
        document.removeEventListener('DOMContentLoaded', onReady);
        scheduleRender();
        initObserver();
      },
      { once: true },
    );
  } else {
    scheduleRender();
    initObserver();
  }
})();
